<template>
  <a-form
    :form="form"
    :label-col="{ span: 5 }"
    :wrapper-col="{ span: 12 }"
    @submit="handleSubmit"
  >
    <a-form-item label="Статусы">
      <multiselect
        v-model="added"
        tag-placeholder="Добавьте отделы"
        placeholder="Добавьте отделы"
        label="name"
        track-by="id"
        :options="departments"
        :multiple="true"
        :taggable="false"
        deselect-label="Удалить"
        select-label="Добавить"
      ></multiselect>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
      <a-button type="primary" html-type="submit">
        Сохранить
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
import bent from 'bent';
import Multiselect from 'vue-multiselect';

export default {
  props: [
    'baseUrl',
    'panelId',
    'password',
    'adminpassword',
    'deps',
    'addedDeps',
  ],
  components: {
    Multiselect,
  },
  data() {
    return {
      type: null,
      added: [],
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      post: {},
    };
  },
  async mounted() {
    this.post = bent(this.baseUrl, 'POST', 'json', 200);
    this.init();
  },
  watch: {
    addedDeps(value) {
      this.added = value;
    },
  },
  computed: {
    departments() {
      return Object.entries(this.deps).map((e) => ({
        id: e[1].id,
        name: e[1].name,
      }));
    },
  },
  methods: {
    async init() {
      this.added = this.addedDeps;
    },
    async addDepsToDb(added) {
      console.log('add deps to db', added);
      try {
        await this.post('addDeps', {
          panelId: this.panelId,
          password: this.password,
          adminpassword: this.adminpassword,
          added,
        });
      } catch (error) {
        console.log(error);
        alert('Ошибка сохранения');
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err) => {
        if (!err) {
          await this.addDepsToDb(this.added);
          this.$emit('depsChange', {});
        }
      });
    },
  },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
.table-operations {
  margin-bottom: 16px;
}

.table-operations > button {
  margin-right: 8px;
}

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.dynamic-delete-button:hover {
  color: #777;
}
.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

button:disabled {
  display: none;
}
</style>
